<template>
  <!--srcviewscompanylistriskvuehtmlStart-->
  <div>
    <div
      id="defaultId1"
      class="uedbd2"
      style="display: flex; height: 100%; background: #f5f5f5"
    >
      <div
        style="overflow: hidden; transition: 0.2s; flex: 0 0 auto"
        :class="$store.state.app.isMenu ? '' : 'hidemenu'"
        v-loading="RiskLoding"
      >
        <div style="height: 99%; padding-bottom: 11%">
          <div :class="!this.Compare ? '' : 'vague'" style="height: 99%">
            <div class="left_menu margin-top30" style="height: 99%">
              <div class="FilterQuestion">
                <div class="left_menu_question">
                  <div class="table">
                    <div class="left_menu_context">
                      <p class="left_menu_context-title">
                        {{ $t("TradeByCountry.TransactionYear") }}
                        <span class="Clear_all" @click="clearAllTags"
                          ><i
                            class="iconfont icon-qingchu"
                            style="color: #ff6a6a; margin-right: 5px"
                          ></i
                          >{{ $t("SearchTrade.ClearAll") }}</span
                        >
                      </p>

                      <el-select
                        filterable
                        v-model="datePickerYear"
                        clearable
                        :popper-append-to-body="false"
                        @change="ChangeRadio"
                        style="width: 100%"
                        :placeholder="$t('TradeByCountry.SelectTransactionYear')"
                      >
                        <el-option
                          v-for="item in datePickerYearList"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>

                    <div class="left_menu_context">
                      <p class="left_menu_context-title">{{ $t("TradeByCountry.ProductName") }}</p>

                      <el-select
                        filterable
                        v-model="ProductName"
                        clearable
                        :popper-append-to-body="false"
                        @change="ChangeRadio"
                        class="search-select-con"
                        style="width: 100%"
                        :placeholder="$t('TradeByCountry.SelectProductName')"
                      >
                        <el-option
                          v-for="item in ProductNameList"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        >
                          <el-tooltip
                            effect="light"
                            :content="item.name"
                            placement="top"
                            :disabled="item?.name?.length < 24"
                          >
                            <span
                              style="
                                display: block;
                                max-width: 21rem;
                                line-height: auto;
                              "
                              class="Country_name"
                            >
                              {{ item.name }}</span
                            >
                          </el-tooltip>
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="cc5f49"
        :class="
          $store.state.app.isMenu
            ? 'scrollbar scrollbar_right'
            : ' scrollbar scrollbar_right udb507two'
        "
      >
        <div style="height: 100%" v-loading="RiskLoding">
          <div class="list-label" v-show="!Compare" style="height: 100%">
            <div
              id="c6d65e"
              class="ub7918 Alchecked flex_center_bettwen"
              style="padding-left: 20px; align-items: center"
            >
              <div>
                <el-checkbox
                  v-if="isOpenSlct"
                  style="margin-right: 20px"
                  id="c0b733"
                  v-model="checked"
                  label
                  @change="changeSlctAll"
                  >{{ $t("TradeByCountry.All") }}</el-checkbox
                >
              </div>
            </div>
            <div
              class="flex_center_between_box"
              style="width: 100%; height: 98%"
            >
              <div class="risk-center-list">
                <div class="flex_center margin-bottom20">
                  <ul class="flex_center Data-Management-ul">
                    <li
                      v-for="(item, index) in managementMenu"
                      @click="MenuClick(item)"
                      :class="
                        menuActive == item.value
                          ? 'menuActiveColor font18 font_bold'
                          : 'font18'
                      "
                      :key="index"
                    >
                      {{ item.label }}
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 class="operations-head-content">
                    <div>
                      <span v-if="menuActive == 1" class="operations-headspan"
                        >{{ $t("TradeByCountry.ListofImportProducts") }}</span
                      >
                      <span v-else class="operations-headspan"
                        >{{ $t("TradeByCountry.ListofExportProducts") }}</span
                      >
                      <span class="tptitleSplit">|</span>
                      <span
                        v-if="menuActive == 1"
                        class="font1A2332 font18 font_bold"
                        >{{ $t("TradeByCountry.Totalnumberofimportedproducts") }}:
                        <span class="font_bold" style="color: #009ea7; margin-left: 5px;font-size: 20px;">{{ page.total | FilterNum }}</span>
                        </span
                      >
                      <span v-else class="font1A2332 font18 font_bold"
                        >{{ $t("TradeByCountry.Totalnumberofexportedproducts") }}:
                        <span class="font_bold" style="color: #009ea7; margin-left: 5px;font-size: 20px;">{{ page.total | FilterNum }}</span></span
                      >
                    </div>
                  </h3>
                  <ul>
                    <draggable
                      filter=".forbid"
                      v-model="CompanyList"
                      :disabled="disabled"
                      animation="300"
                      :move="onMove"
                    >
                      <transition-group>
                        <li
                          v-for="(item, index) in CompanyList"
                          :key="index"
                          :class="
                            item.isDing
                              ? 'conpany-center-list forbid item'
                              : 'conpany-center-list item'
                          "
                        >
                          <div
                            class="flex_between_box"
                            style="align-items: center"
                          >
                            <div class="conpany-center-list-left">
                              <el-checkbox
                                v-if="isOpenSlct"
                                id="cee084"
                                style="margin-right: 10px; margin-top: 0.3rem"
                                v-model="item.isChecked"
                                label
                                @change="changeItemChecked"
                              >
                              </el-checkbox>
                              <span
                                :class="
                                  item.isDing
                                    ? 'indexPositon'
                                    : 'indexPositonactive'
                                "
                                >{{ index + 1 }}</span
                              >
                              <div style="width: 100%">
                                <p class="productTitle" style="width: 100%">
                                  <span
                                    style="font-family: 'Arial Bold'"
                                    class="CountryActive"
                                    @click="exportCompanyImport(item)"
                                    :class="{
                                      overexperise: NationalIndustryShow,
                                    }"
                                    >{{ item.hscodeDescEn }}</span
                                  >
                                </p>

                                <p class="list-text-color">
                                  <span class="font666666" style="">
                                    {{ $t("TradeByCountry.HSCode") }}:</span
                                  >

                                  <span
                                    :class="{
                                      overexperise: NationalIndustryShow,
                                    }"
                                  >
                                    {{ item.hscode }}
                                  </span>
                                  <span class="fontDDDDDD margin-left10"
                                    >|</span
                                  >
                                  <span class="font666666 margin-left10"
                                    >{{ $t("TradeByCountry.HSDescription") }}:</span
                                  >
                                  <span class="overexperise">
                                    <el-popover
                                      :disabled="
                                        item?.hscodeDescEn?.length < 90
                                      "
                                      placement="top"
                                      trigger="hover"
                                      popper-class="table_popover"
                                      :content="item.hscodeDescEn"
                                    >
                                      <span slot="reference">{{
                                        item.hscodeDescEn
                                      }}</span>
                                    </el-popover>
                                  </span>
                                </p>
                                <p class="list-text-color">
                                  <span class="font666666">
                                    {{ $t("TradeByCountry.TransactionYear") }}:</span
                                  >
                                  <span
                                    :class="{
                                      overexperise: NationalIndustryShow,
                                    }"
                                  >
                                    {{ item.latestTransactionDate }}
                                  </span>
                                  <span class="fontDDDDDD margin-left10"
                                    >|</span
                                  >

                                  <span
                                    v-if="menuActive == 1"
                                    class="margin-left10 font666666"
                                    >{{ $t("TradeByCountry.TotalImportAmount") }}:</span
                                  >
                                  <span v-if="menuActive == 1">{{
                                    item.totalImportAmount | FormatNum
                                  }}</span>
                                  <span
                                    v-if="menuActive == 2"
                                    class="margin-left10 font666666"
                                    >{{ $t("TradeByCountry.TotalExportAmount") }}:</span
                                  >
                                  <span v-if="menuActive == 2">{{
                                    item.totalExportAmount | FormatNum
                                  }}</span>
                                  <span
                                    v-if="menuActive == 1"
                                    class="fontDDDDDD margin-left10"
                                    >|</span
                                  >

                                  <span
                                    v-if="menuActive == 1"
                                    class="margin-left10 font666666"
                                    >{{ $t("TradeByCountry.NumberofImportProducts") }}:</span
                                  >
                                  <span v-if="menuActive == 1">{{
                                    item.importFrequency | FormatNum
                                  }}</span>
                                  <span
                                    v-if="menuActive == 2"
                                    class="fontDDDDDD margin-left10"
                                    >|</span
                                  >
                                  <span
                                    v-if="menuActive == 2"
                                    class="margin-left10 font666666"
                                  >
                                    {{ $t("TradeByCountry.NumberofExportProducts") }}:</span
                                  >
                                  <span v-if="menuActive == 2">{{
                                    item.exportFrequency | FormatNum
                                  }}</span>
                                </p>
                                <p
                                  class="list-text-color flagDiv"
                                  v-if="item?.topCountries && CountryCode == ''"
                                  style="align-items: center"
                                >
                                  <span
                                    class="font666666"
                                    v-if="menuActive == 1"
                                  >
                                    {{ $t("TradeByCountry.Top5ExportCountries") }}:
                                  </span>
                                  <span v-else class="font666666">
                                    {{ $t("TradeByCountry.Top5ImportCountries") }}:
                                  </span>
                                  <span
                                    style="margin: 0"
                                    v-for="(ite, index) in item?.topCountries"
                                    :key="index"
                                  >
                                    <el-popover
                                      placement="top"
                                      trigger="hover"
                                      style="margin: 0"
                                      popper-class="table_popover"
                                      :content="ite?.countryName"
                                    >
                                      <img
                                        class="contry_img"
                                        slot="reference"
                                        :src="ite.flag"
                                      />
                                    </el-popover>
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div class="conpany-center-list-right">
                              <p>
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content='$t("TradeByCountry.SearchTrade")'
                                >
                                  <span
                                    slot="reference"
                                    class="iconbg flex_center"
                                  >
                                    <i
                                      @click="exportCompanyImport(item)"
                                      class="iconfont icon-lishibaogao"
                                      style="color: #009ea7"
                                    ></i>
                                  </span>
                                </el-popover>
                              </p>
                            </div>
                          </div>
                        </li>
                      </transition-group>
                    </draggable>
                  </ul>
                  <div
                    class="ShowAll flex_center font18 margin-top20"
                    v-if="page.pageSize < page.total"
                    @click="ShowAll"
                  >
                    {{ $t("SearchTrade.ShowAll") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Login :loginAndCreatePop.sync="loginDialog"></Login>
  </div>
  <!--srcviewscompanylistriskvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import draggable from "vuedraggable";
import { findPartnerDetail } from "@/api/searchApi.js";

import Login from "@/components/login.vue";

import {
  getsearchExport,
  getHuokePartPrivilege,
  searchMoreEmail,
  getCompanyTradeProductInformation,
  filterConditionsOfCompanyTradeProduct,
} from "@/api/companyApi.js";
import { mixins1 } from "@/mixins/index";
export default {
  name: "",
  props: {},
  watch: {},
  mixins: [mixins1],
  components: {
    draggable,
    Login,
  },

  data() {
    return {
      PCMoudele: [],
      menuActive: 1,
      LastUpdate: "",
      loginDialog: false,
      Compare: false,
      supplierNamevalue: "",
      supplierNameList: [],
      Improtradio: "",
      buyerNameList: [],
      buyerNamevalue: "",
      isShowTooltip: false,
      RiskLoding: false,
      MainProductsShow: "",

      compareList: [],
      totle: 0,
      checked: "",
      pageNo: 1,
      disabled: false,
      NationalIndustryActive: "null",
      isRotated: false,

      NationalIndustryShow: false,

      isOpenSlct: false,

      checkList: [],
      aaaid: "",

      CompanyList: [],
      parentTable: [],
      token: localStorage.getItem("token"),
      Saved: undefined,
      isChecked: "",
      DetailsFormImportlist: [],
      riskTotal: "",
      QuestionPageList: [],

      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      chageItIndex: 0,
      chageItTrue: false,
      datePickerYearList: [],
      datePickerYear: "",
      ProductNameList: [],
      ProductName: "",
      CountryList: [],
      CountryCode: "",
    };
  },
  methods: {
    ShowAll() {
      this.page.pageSize = this.page.pageSize + 10;
      this.getSearchList();
    },
    clearAllTags() {
      this.ProductName = "";
      this.datePickerYear = "";
      this.ChangeRadio();
    },

    ChangeRadio() {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = "null";

      this.page.pageSize = 10;
      this.getSuppliersAndBuyersFilterList();
      this.getSearchList();
    },
    getSuppliersAndBuyersFilterList() {
      filterConditionsOfCompanyTradeProduct({
        aaaid: "",
        type: this.menuActive,
        hscode: this.ProductName,
        countryCode: this.$route.query.id3a,
        impYear: this.datePickerYear,
      }).then((res) => {
        if (res.code == 200) {
          this.ProductNameList = res.data.productName;
          this.CountryList = res.data.country;
          this.datePickerYearList = res.data.years;
        }
      });
    },
    // 获取列表数据
    getSearchList(leadsPostFilter) {
      this.RiskLoding = true;
      getCompanyTradeProductInformation({
        aaaid: "",
        type: this.menuActive,
        page: 1,
        pageSize: this.page.pageSize,
        countryCode: this.$route.query.id3a,
        impYear: this.datePickerYear,
        hscode: this.ProductName,
      }).then((res) => {
        if (res.code == 200) {
          this.RiskLoding = false;
          this.page.total = res.data.total;
          let parentTable = res.data.rows;
          parentTable.map((item, index) => {
            if (item.topCountries) {
              item.MainProductsShow = false;
              this.refresh++;
              item.topCountries.map((ite, ind) => {
                let countryImg = this.getCountryImgUrl(ite.countryCode);

                if (countryImg) {
                  let flag = require("../../../../../static" + countryImg);
                  ite.flag = flag;
                }
              });
            }
          });
          this.CompanyList = parentTable;
        } else {
          this.RiskLoding = false;
        }
      });
    },

    MenuClick(item) {
      this.menuActive = item.value;
      this.ChangeRadio();
    },

    rifghtUpdate() {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = "null";
    },
    // echarts监听 浏览器宽度改变 echarts改变

    // 获取权限
    getHuokePartPrivilegeList() {
      getHuokePartPrivilege({
        moduleType: 7,
      }).then((res) => {
        if (res.code == 200) {
          this.PCMoudele = res.data;
        }
      });
    },

    // web导出
    exportCompanyWeb(item) {
      this.chageItTrue = true;
      if (this.PCMoudele[14].hasPrivilege) {
        this.aaaId = item.aaa_id;
        this.itemList = item;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }

      // this.DetailsForm = [];
      // this.DetailsForm.push(item);
    },
    DetailsFormConcat() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        let params = {
          page: 1,
          pageSize: 100,
          id3a: this.aaaId,
          website: this.itemList.web_site,
          countryCode: this.itemList.company_country,
        };
        //    return   this.DetailsFormImportlist
        return searchMoreEmail(params).then((res) => {
          if (res.code == 200) {
            if (res.data.contacts.length == 0) {
              this.$message({
                message: "No Data",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.contacts;
          } else {
            return [];
          }
        });
      }
    },

    // 贸易链路导出
    exportCompanyImport(item) {
      let routeData = this.$router.resolve({
        path:
          "/index/TradeProduct/TradeDetail/" +
          item.hscode +
          "/tradeMap/map?id3a=" +
          item.hscode +
          "&Tradechannel=HsCode" +
          "&Moudles=Trade",
      });
      window.open(routeData.href, "_blank");
    },

    // 点击跳转
    setNews(row, detail) {
      if (this.token) {
        this.chageItTrue = true;
        // sessionStorage.setItem("company", JSON.stringify(row));
        let newscountry = JSON.parse(localStorage.getItem("countryList"))[0]
          .countryList;
        let SACode1 = "";
        newscountry.map((item) => {
          if (item.countryCode == row.company_country) {
            SACode1 = item.dowjonesCountrycode;
          }
        });
        let routeData = "";
        if (detail == "prife") {
          routeData = this.$router.resolve({
            path:
              "/index/company/details/" +
              row.aaa_id +
              "/background/snapshot?id3a=" +
              row.aaa_id +
              "&companyCountry=" +
              row.company_country +
              "&SACode1=" +
              SACode1 +
              "&companyName=" +
              row.company_name_en +
              "&keword=" +
              this.$route.query.keword,
          });
        } else {
          routeData = this.$router.resolve({
            path:
              "/index/company/details/" +
              row.aaa_id +
              "/publications/news?id3a=" +
              row.aaa_id +
              "&companyCountry=" +
              row.company_country +
              "&SACode1=" +
              SACode1 +
              "&idpower=442" +
              "&companyName=" +
              row.company_name_en +
              "&keword=" +
              this.$route.query.keword,
          });
        }

        window.open(routeData.href, "_blank");
      }
    },

    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // 工具栏高亮控制
    setToolsAcive() {
      this.$store.dispatch("app/setTools", {
        name: "Optimize",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });

      //   this.$store.dispatch("app/setTools", "filter",'isActive',false);
    },
    // 收藏

    // 删除元素
    DelClick(item, index) {
      if (this.PCMoudele[13].hasPrivilege) {
        this.deledeLaeadsDialog = true;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },

    // 移动
    onMove(e) {
      if (e.relatedContext.element.isDing == true) return false;
      return true;
    },

    // 全选操作
    changeItemChecked(value) {
      if (this.CompanyList.filter((item) => item.isChecked).length > 0) {
        this.checked = true;
      } else {
        this.checked = false;
      }

      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.$store.dispatch("app/setchangeList", selectCompany);
      this.compareList = selectCompany;
      // this.$nextTick(() => { });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: selectCompany.length > 0 && this.SavyeLeadsSuo == false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true && this.Compare == false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: this.compareList.length > 0 && this.compareList.length < 4,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: selectCompany.length > 0,
      });
    },
    // 全选操作
    changeSlctAll(value) {
      this.CompanyList.forEach((item) => {
        item.isChecked = value;
      });
      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.compareList = selectCompany;
      this.$store.dispatch("app/setchangeList", selectCompany);
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "highlight-cell"; // 设置你想要的背景色
      }
    },

    // setTools
    setTools() {
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
    }, // getDetail
  },
  computed: {
    managementMenu(){
      return [
        {
          label: this.$t("SearchTrade.Imports"),
          value: "1",
        },
        {
          label: this.$t("SearchTrade.Exports"),
          value: "2",
        },
      ]
    } 
  },
  created() {
    this.setToolsfalse();
  },
  mounted() {
    this.$store.dispatch("app/setTools", {
      name: "menu",
      key: "isActive",
      value: true,
    });
    this.$emit("UpdatamarkTotalList", true);

    //
    this.getSuppliersAndBuyersFilterList();
    this.getSearchList();
    this.setToolsfalse();
    if (this.token) {
      this.getHuokePartPrivilegeList();
    }
  },
  beforeDestroy() {},
};
</script>
<style scoped>
.operations-headspan{
  color: #009ea7;
}

.ud6279 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 7.642857142857143rem;
}

.u96d4d {
  width: 29rem;
}

.uba4wV3 {
  margin-right: 1.0714285714285714rem;
  margin-bottom: 0.7142857142857143rem;
  margin-top: 0.7142857142857143rem;
  margin-left: 1.0714285714285714rem;
}

.ub7918 {
  color: #999999;
  margin-bottom: 0.7142857142857143rem;
  font-size: 1.1428571428571428rem;
  text-align: left;
  font-style: normal;

  margin-bottom: 0.7142857142857143rem;
  overflow: hidden;
}

.uVwoZks {
  width: 100%;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.udb507 {
  width: calc(100% - 300px);
  display: flex;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  flex-direction: column;
  margin-left: 10px;
  background: #ffffff;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

.scrollbar {
  overflow: hidden;
}

.udb507two {
  width: 100%;
}

.risk-right {
  width: 540px;
  padding: 20px;
  background: #ddedee;
  height: 45rem;
  border-radius: 0 10px 10px 10px;
}

.risk-center-list {
  flex: 1;
  width: 49%;
  overflow-y: scroll;
}

.Upadetime {
  font-size: 1.2857142857142858rem;
  color: #666666;
  margin-right: 2.142857142857143rem;
}

.flex_center_between_box p {
  font-size: 24px;
  color: #1a2332;
  min-height: 22px;
  margin-bottom: 16px;
  display: flex;
  align-items: self-start;
}

.risk-right-content {
  padding: 1.4285714285714286rem 0rem;
  border-top: 0.07142857142857142rem solid #cccccc;
}

.risk-right-content-title {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  height: 1.7142857142857142rem;
  margin-bottom: 1.4285714285714286rem;
  font-family: "Arial Bold";
}

.right-txt {
  text-align: right;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  line-height: 1.8571428571428572rem;
}

.left-txt {
  font-size: 1.2857142857142858rem;
  color: #666666;
}

.margin16 {
  margin-top: 1.1428571428571428rem;
}

.highlight-cell {
  background-color: #f2f5f9 !important;
}

.risk-right .el-table .cell {
  color: #1a2332;
}

.table-content {
  height: 3.5714285714285716rem !important;
  line-height: 3.5714285714285716rem;
}

.risk-right .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.conpany-center-list {
  padding: 30px 40px 9px 20px;
  background: #f5f5f5;
  border-radius: 10px;
  margin-bottom: 10px;
  overflow: hidden;
}

.conpany-center-list-left {
  font-size: 24px;
  color: #1a2332;
  display: flex;
  align-items: flex-start;
  width: 90%;
}

.risk-center-list .el-checkbox__inner,
.Alchecked .el-checkbox__inner {
  height: 1.4285714285714286rem !important;
  width: 1.4285714285714286rem !important;
}

.conpany-center-list-left .el-checkbox__inner {
  margin-top: 0.2857142857142857rem !important;
}

.risk-center-list .el-checkbox__inner::after,
.Alchecked .el-checkbox__inner::after {
  height: 0.7142857142857143rem;
  left: 0.5rem;
}

.risk-center-list .el-checkbox__input.is-checked .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #8e86dd;
  border-color: #8e86dd;
}

.risk-center-list .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked
  .el-checkbox__inner:hover
  .risk-center-list
  .el-checkbox__inner:hover {
  border: 0.07142857142857142rem solid #dcdfe6;
}

.risk-center-list .el-checkbox__input.is-checked + .el-checkbox__label,
.Alchecked .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1a2332;
}

.indexPositon {
  margin-right: 1.4285714285714286rem;
  color: #009ea7;
  width: 1.4285714285714286rem;
}

.indexPositonactive {
  margin-right: 10px;
  color: #999999;
  width: 30px;
  font-family: "Arial Bold";
  min-width: 30px;
}

.list-text-color {
  font-size: 18px !important;
  color: #666666 !important;
  display: flex;
  align-items: center;
}

.list-text-color span {
  color: #1a2332;
  margin-right: 10px;
}

.overexperise {
  max-width: 60%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: fit-content !important;
}

.list-text-color img,
.contry_img {
  width: 60px;
  height: 40px;
  padding: 5px;
}

.margin20 {
  margin-left: 1.4285714285714286rem;
}

.iconbg {
  width: 3.5714285714285716rem;
  height: 3.5714285714285716rem;
  background: #ddedee;
  border-radius: 50%;
  cursor: pointer;
}

.conpany-center-list-right p {
  justify-content: flex-end;
  margin-bottom: 0px;
}

.bottom-list-echarts {
  padding-left: 2.8142857142857144rem;
  display: flex;
  justify-content: space-between;
}

.bottom-list-echarts-li {
  padding: 1.4285714285714286rem;
  background: #f5f5f5;
  height: 18.571428571428573rem;
  width: 33%;
  padding-bottom: 0.7142857142857143rem;
}

.icontransform {
  display: inline-block;
  transition: transform 0.5s ease;
  /* 设置过渡效果 */
  cursor: pointer;
}

.rotate {
  transform: rotate(-180deg);
  /* 旋转180度 */
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在 Vue 2.x 中 */ {
  opacity: 0;
  /* 初始透明度 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  /* 淡入淡出动画 */
}

.left_menu_title {
  font-size: 1.7142857142857142rem;
  color: #1a2332;
  margin: 1.4285714285714286rem 0rem;
  padding-bottom: 10px;
  border-bottom: 1px solid #dddddd;
  font-family: "Arial Bold";
}

.left_menu_question p {
  font-size: 18px;
  color: #1a2332;
  margin-bottom: 10px;
  font-family: "Arial Bold";
}

.left_menu_question .el-input__inner {
  height: 2.5714285714285716rem;
  background: #ffffff;
  border-radius: 10px;
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  padding-left: 0.7142857142857143rem !important;
}

.left_menu_question /deep/ .el-select .el-input.is-focus .el-input__inner,
.left_menu_question /deep/ .el-select .el-input__inner:focus {
  border: 0.07142857142857142rem solid #cccccc !important;

  line-height: 2.428571rem !important;
}

.left_menu_question {
  margin-bottom: 0.7142857142857143rem;
  padding-bottom: 1.4285714285714286rem;
}

.FilterQuestion .left_menu_question {
  padding-bottom: 0rem;
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #f5f5f5;
  border-color: #cccccc;
  color: #999999;
  line-height: 2.428571rem !important;
}

.left_menu_bottom {
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  margin-bottom: 3rem;
}

.profit-txt {
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.color1290C9 {
  text-align: right;
}

.question-detail_cont-list h3 {
  margin-top: 0.7142857142857143rem;
  font-family: "Arial ";
  font-weight: 400;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
}

button:disabled {
  cursor: no-drop !important;
}

.el-popover {
  padding: 10px !important;
  min-width: auto;
}

.uedbd2 {
  height: 100%;
}

.right_cont_box {
  height: 100%;
  overflow-y: auto;
}

.IElabel {
  font-size: 16px;
  color: #ff7600;
  text-align: center;
  background: #fff8f1;
  line-height: 26px;
  width: 70px;
  border-radius: 10px;
  border: 1px solid #ff7600;
}

.IElabelExport {
  background: #f4fbff;
  border-radius: 10px;
  border: 1px solid #1290c9;
  color: #1290c9;
}

.left_menu_context-title {
  font-size: 18px;
  color: #1a2332;
  font-family: "Arial Bold";
  margin-bottom: 20px;
  position: relative;
}

.left_menu_context {
  margin-bottom: 30px;
}

.left_menu_context /deep/ .el-input__inner {
  height: 36px !important;
}

/deep/ .el-radio {
  justify-content: flex-start;
  font-size: 1.1428575rem;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #009ea7;
  font-size: 16px;
}

/deep/ .el-radio__label {
  font-size: 16px;
  color: #1a2332;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #009ea7;
  background: #fff;
}

/deep/ .el-radio__input.is-checked .el-radio__inner::after {
  background: #009ea7;
}
.margin-left10 {
  margin-left: 10px !important;
  cursor: pointer;
}

.Clear_all {
  position: absolute;
  right: 0px;
  font-size: 16px;
  z-index: 999;
  cursor: pointer;
}

.MainProducts {
  background: #f5f5f5;
  border-radius: 10px;
  border: 1px solid #009ea7;
  padding: 5px;
  margin-bottom: 5px;
  font-size: 16px;
  color: #009ea7;
  display: inline-block;
}

.MainProductsAll {
  width: 30px;
  height: 30px;
  background: #ddedee;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  color: #009ea7;
  cursor: pointer;
}

.MainProductsMainProducts {
  width: 80%;
  height: 30px;
  overflow: hidden;
}

.iconbgActiveBG {
  background: #ddedee;
}

.iconbgActiveBG .iconbgActive {
  background: #009ea7;
}

.iconbgActiveBG {
  margin-right: 0px;
  border-radius: 10px 0px 0px 10px;
}

/deep/ .el-scrollbar__wrap {
  max-width: 21rem !important;
}
.icon-lishibaogao {
  font-size: 22px;
}
.productTitle {
  min-height: 34px;
}
.flagDiv {
  min-width: 630px;
}
.list-text-color img,
.contry_img {
  width: 45px;
  height: 30px;
  padding: 4px;
}

/* .TotalNumber {
  margin-left: 20px;
} */

.tptitleSplit {
  color: #cccccc;
  font-size: 20px;
  line-height: 20px;
  margin: 20px 30px;
}

@media (max-width: 1920px) {
  .left_menu_question p {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .left_menu_question {
    margin-bottom: 7px;
    padding-bottom: 15px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .Clear_all {
    font-size: 14px;
  }
  .trade_date_picker,
  .left_menu_context /deep/ .el-input__inner {
    height: 32px !important;
    font-size: 14px;
  }
  .trade_date_picker {
    width: 225px;
  }
  .trade_bottom_right_top {
    margin-bottom: 7px;
    font-size: 14px;
  }
  .conpany-center-list {
    padding: 22px 30px 7px 15px;
    margin-bottom: 7px;
  }
  .flex_center_between_box p {
    font-size: 18px;
    min-height: 16px;
    margin-bottom: 12px;
  }
  .indexPositonactive {
    margin-right: 7px;
    width: 22px;
    min-width: 22px;
  }
  .conpany-center-list-left {
    font-size: 18px;
  }
  .icon-lishibaogao {
    font-size: 20px;
  }
  .icon-shoucang {
    font-size: 20px;
  }
  .icon-arrowup-copy,
  .icon-arrowup {
    font-size: 16px;
    margin-right: 7px;
  }
  .list-text-color {
    font-size: 16px !important;
  }
  .list-text-color span {
    margin-right: 8px;
  }
  .iconbg {
    width: 37px;
    height: 37px;
  }
  .risk-right {
    width: 480px;
    padding: 15px;
    height: 43rem;
  }

  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #009ea7;
    font-size: 14px;
  }

  /deep/ .el-radio__label {
    font-size: 14px;
    color: #1a2332;
  }

  .margin-left10 {
    margin-left: 8px !important;
    cursor: pointer;
  }
  .margin-top4 {
    margin-top: 3px !important;
    cursor: pointer;
  }
  .productTitle {
    min-height: 26px;
  }
  .udb507 {
    width: calc(100% - 255px);
  }
  .left_menu_context-title {
    font-size: 16px;
    margin-bottom: 7px;
  }
  
  .tptitleSplit {
    font-size: 20px;
    line-height: 20px;
    margin: 10px 23px;
  }
}

@media screen and (max-width: 1439px) {
  .left_menu_question p {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .left_menu_question {
    margin-bottom: 6px;
    padding-bottom: 13px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .Clear_all {
    font-size: 12px;
  }
  .trade_bottom_right_top {
    margin-bottom: 6px;
    font-size: 12px;
  }
  .conpany-center-list {
    padding: 20px 27px 6px 13px;
    margin-bottom: 6px;
  }
  .flex_center_between_box p {
    font-size: 16px;
    min-height: 15px;
    margin-bottom: 10px;
  }
  .indexPositonactive {
    margin-right: 6px;
    width: 20px;
    min-width: 20px;
  }
  .conpany-center-list-left {
    font-size: 16px;
  }
  .icon-lishibaogao {
    font-size: 15px;
  }
  .icon-shoucang {
    font-size: 18px;
  }
  .icon-arrowup-copy,
  .icon-arrowup {
    font-size: 16px;
    margin-right: 6px;
  }
  .list-text-color img {
    width: 24px;
    margin-right: 3px;
  }
  .list-text-color {
    font-size: 14px !important;
  }
  .list-text-color span {
    margin-right: 7px;
  }
  .iconbg {
    width: 33px;
    height: 33px;
  }
  .risk-right {
    width: 500px;
    padding: 13px;
    min-height: 42rem;
  }
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #009ea7;
    font-size: 12px;
  }

  /deep/ .el-radio__label {
    font-size: 12px;
    color: #1a2332;
  }
  .margin-left10 {
    margin-left: 7px !important;
    cursor: pointer;
  }
  .margin-top4 {
    margin-top: 3px !important;
    cursor: pointer;
  }
  .productTitle {
    min-height: 23px;
  }
  .list-text-color img,
  .contry_img {
    width: 40px;
    height: 26px;
    padding: 3px;
  }
  .udb507 {
    width: calc(100% - 225px);
  }
  .left_menu_context-title {
    font-size: 14px;
    margin-bottom: 6px;
  }
  
  .tptitleSplit {
    font-size: 20px;
    margin: 20px;
  }
}
</style>
